import React from "react";
import { alpha, Box, Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { Vendor, VendorMeta } from "../vendorConfig";

interface Props {
  vendor: Vendor;
  selected: boolean;
  onSelect: (vendor: Vendor) => void;
  meta: VendorMeta;
}

export const VendorCard: React.FC<Props> = ({ vendor, selected, onSelect, meta }) => (
  <Card
    variant="outlined"
    sx={{
      borderRadius: 3,
      borderColor: selected ? meta.accent : "divider",
      borderWidth: selected ? 2 : 1,
      bgcolor: selected ? alpha(meta.accent, 0.04) : "background.paper",
      boxShadow: selected ? `0 4px 20px ${alpha(meta.accent, 0.15)}` : "none",
      transition: "all .2s ease-in-out",
      "&:hover": {
        borderColor: meta.accent,
        bgcolor: alpha(meta.accent, 0.04),
        transform: "translateY(-2px)",
        boxShadow: `0 6px 24px ${alpha(meta.accent, 0.12)}`,
      },
    }}
  >
    <CardActionArea onClick={() => onSelect(vendor)} sx={{ p: 0.5 }}>
      <CardContent sx={{ py: 2.5 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Box
            sx={{
              position: "relative",
              width: 56,
              height: 56,
              borderRadius: 2,
              overflow: "hidden",
              border: `1px solid ${alpha(meta.accent, 0.2)}`,
              flexShrink: 0,
            }}
          >
            <Box
              component="img"
              src={meta.logo}
              alt={meta.label}
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={700} sx={{ color: selected ? meta.accent : "text.primary" }}>
              {meta.label}
            </Typography>
          </Box>
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              border: selected ? "none" : "2px solid",
              borderColor: "divider",
              bgcolor: selected ? meta.accent : "transparent",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all .2s ease-in-out",
              flexShrink: 0,
            }}
          >
            {selected && <CheckCircle sx={{ fontSize: 28, color: "#fff" }} />}
          </Box>
        </Stack>
      </CardContent>
    </CardActionArea>
  </Card>
);
